<template>
  <b-modal id="modal-challenge" class="modal-challenge" centered :no-enforce-focus="true">
    <div class="modal-challenge-itens">
      <div class="modal-challenge-itens-header">
        <button class="modal-challenge-itens-close" @click="hideModalChallenge()">
          <div class="modal-challenge-itens-close--icon">
            <img class="img-fluid" src="@/assets/img/close-modal.png" alt="icon close" title="icon close"/>
          </div>
        </button>
      </div>
      <form class="modal-challenge-itens-body" @submit.prevent="handleSubmit()">
        <div class="modal-challenge--header">
          <h2>Desafios</h2>
          <img class="img-fluid" src="@/assets/img/fogueira.png" alt="image fire" title="image fire"/>
        </div>
        <div class="modal-challenge--form">
          <div class="content-input-default">
            <textarea name="description" v-model="modalChallenge.description" placeholder="Descrição" required></textarea>
          </div>
        </div>
        <div class="modal-challenge-btn">
          <button class="btn-green">
            Salvar
          </button>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      modalChallenge: {
        description: '',
      },
    }
  },
  computed: {
    ...mapGetters('Tasks', ['currentTask','challenges', 'editModalChallenge']),
    ...mapGetters('User', ['user']),
  },
  watch: {
    editModalChallenge: {
      handler(newValue){
        if (Object.keys(newValue).length > 0) {
          this.modalChallenge = {...newValue};
        }
      }
    }
  },
  methods: {
    ...mapActions('Tasks', ['registerChallengesTasks']),
    async handleSubmit() {
      let message = this.modalChallenge?.id_tc ? 'Editado com sucesso!' : 'Cadastrado com sucesso!';
      this.modalChallenge.id_user = this.user.id;
      this.modalChallenge.id_task = this.currentTask.id;
      this.modalChallenge.id_challenge = this.challenges.id;

      await this.registerChallengesTasks(this.modalChallenge);
      this.$swal.fire({ icon: 'success', html: message })

      if (!this.modalChallenge?.id_tc){ this.clearInput(); }
      this.hideModalChallenge();
    },
    clearInput() {
      this.modalChallenge.description = '';
    },
    hideModalChallenge() {
      this.$bvModal.hide('modal-challenge');
    },
  },
}
</script>

<style lang="scss">
#modal-challenge {
  @media (max-width: 991px){
    top: initial;
    bottom: 0;
    background: var(--white);
    box-shadow: 0px 3px 16px rgba(0,0,0,0.16);
  }
	.modal-header, .modal-footer {
		display: none;
	}
	.modal-dialog {
		max-width: 500px;
    @media (max-width: 991px){
      max-width: 100%;
      min-height: 100%;
      height: 100%;
      margin: 0;
    }
	}
	.modal-content {
		box-shadow: 0px 3px 16px rgba(0,0,0,0.16);
		border: 0;
    border-radius: 20px;
    @media (max-width: 991px){
      height: 100%;
      box-shadow: none;
    }
	}
	.modal-body {
		padding: 0;
	}
}
.modal-challenge {
	&-itens {
		&-close {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 10px;
      border: 0;
      background: 0;
      transition: 500ms;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.8;
      }
		}
    &-body {
      padding: 25px 20px 30px 20px;
      .modal-challenge {
        &--header {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: 30px;
          h2 {
            font-size: 20px;
            font-family: 'Font Light Italic';
            color: var(--black);
            margin-right: 10px;
            margin-bottom: 0;
          }
        }
        &--form {
          .content-input-default textarea {
            min-height: 250px;
          }
        }
        &-btn {
          margin-top: 50px;
        }
      }
    }
	}
}
</style>
